// Category meta for UI (matches backend slugs)
export const CATEGORY_META = {
  restaurants: { emoji: "🍽", color: "#C4291C", name: "Restaurants" },
  hotels: { emoji: "🏨", color: "#1A5C35", name: "Hôtels" },
  sante: { emoji: "🏥", color: "#1E4D8C", name: "Santé" },
  banques: { emoji: "🏦", color: "#5B2D8E", name: "Banques & Finance" },
  transport: { emoji: "🚗", color: "#B45309", name: "Transport" },
  shopping: { emoji: "🛍", color: "#B91C8B", name: "Shopping" },
  education: { emoji: "📚", color: "#0E7490", name: "Éducation" },
  services: { emoji: "⚙", color: "#047857", name: "Services" },
  beaute: { emoji: "💆", color: "#9D174D", name: "Beauté & Bien-être" },
  telecom: { emoji: "📱", color: "#1D4ED8", name: "Télécom & Tech" },
  immobilier: { emoji: "🏠", color: "#065F46", name: "Immobilier" },
  juridique: { emoji: "⚖", color: "#7C3AED", name: "Juridique & Notaire" },
};

export function getCategory(slug) {
  return CATEGORY_META[slug] || { emoji: "🏷", color: "#1C1917", name: slug };
}

const DAY_KEYS = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
const DAY_LABELS_FR = {
  mon: "Lundi", tue: "Mardi", wed: "Mercredi", thu: "Jeudi",
  fri: "Vendredi", sat: "Samedi", sun: "Dimanche",
};

export function dayLabel(key) {
  return DAY_LABELS_FR[key] || key;
}

export function computeOpenStatus(hours) {
  if (!hours || typeof hours !== "object") return { open: false, label: "Horaires non disponibles" };
  const now = new Date();
  const todayKey = DAY_KEYS[now.getDay()];
  const todayStr = hours[todayKey];
  if (!todayStr || todayStr === "closed") {
    return { open: false, label: "Fermé aujourd'hui" };
  }
  const [start, end] = todayStr.split("-").map((s) => s.trim());
  if (!start || !end) return { open: false, label: "Fermé" };
  const toMin = (s) => {
    const [h, m] = s.split(":").map(Number);
    return h * 60 + (m || 0);
  };
  const cur = now.getHours() * 60 + now.getMinutes();
  const startM = toMin(start);
  const endM = toMin(end);
  if (cur >= startM && cur <= endM) {
    return { open: true, label: `Ouvert · Ferme à ${end}` };
  }
  if (cur < startM) {
    return { open: false, label: `Fermé · Ouvre à ${start}` };
  }
  return { open: false, label: "Fermé" };
}

export function whatsappLink(phone, businessName) {
  const clean = (phone || "").replace(/[^0-9]/g, "");
  const text = encodeURIComponent(
    `Bonjour, j'ai trouvé votre entreprise ${businessName || ""} sur Lokaso et j'aimerais avoir plus d'informations.`
  );
  return `https://wa.me/${clean}?text=${text}`;
}

export function mapsLink(address) {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address || "")}`;
}

export function mapsEmbed(address) {
  return `https://www.google.com/maps?q=${encodeURIComponent(address || "")}&output=embed`;
}
